import { produce } from 'immer'
import { transactionDetailRouteProps } from 'src/navigation/routeProps'
import {
  UPLOAD_ATTACHMENT_FAILURE,
  UPLOAD_ATTACHMENT_INIT,
  UPLOAD_ATTACHMENT_SUCCESS,
  UploadAttachmentActions,
} from 'src/redux/actions/data/receiptAttachments.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'

export interface TransactionDetailState {
  uploadingAttachmentThumbnails: Record<string, string>
}

export const initialState: TransactionDetailState = {
  uploadingAttachmentThumbnails: {},
}

export type Actions = UploadAttachmentActions

const CoreTransactionDetailReducer = (
  state = initialState,
  action: Actions,
): TransactionDetailState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case UPLOAD_ATTACHMENT_INIT: {
        draft.uploadingAttachmentThumbnails = {
          ...draft.uploadingAttachmentThumbnails,
          [action.payload.uploadId]: action.payload.thumbnailUrl,
        }
        return draft
      }

      case UPLOAD_ATTACHMENT_FAILURE: {
        draft.uploadingAttachmentThumbnails = Object.keys(
          draft.uploadingAttachmentThumbnails,
        )
          .filter((id) => id !== action.payload.uploadId)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.uploadingAttachmentThumbnails[curr],
            }),
            {},
          )
        return draft
      }

      case UPLOAD_ATTACHMENT_SUCCESS: {
        draft.uploadingAttachmentThumbnails = Object.keys(
          draft.uploadingAttachmentThumbnails,
        )
          .filter((id) => id !== action.payload.uploadId)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.uploadingAttachmentThumbnails[curr],
            }),
            {},
          )
        return draft
      }
    }
  })
}

const TransactionDetailReducer = createFlyoutReducer(
  transactionDetailRouteProps,
  initialState,
  CoreTransactionDetailReducer,
)

export default TransactionDetailReducer
